'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _Product = require('scripts/modules/Product');

var currentPackItems = []; // Modules

var packContainerId = void 0;
var maxItems = void 0;

var dom = {
  header: 'header',
  packMain: '[pack-main]',
  addToPackBtn: '[add-to-pack]',
  addPackToCart: '[add-pack-to-cart]',
  removeFromPackBtn: '[remove-from-pack]',
  packItem: '[product-pack-option]',
  itemQtyUpdate: '[update-pack-qty]',
  itemQtyInput: '[pack-item-qty-input]',
  packContents: '[pack-contents]',
  packSticky: '[pack-contents-sticky]',
  previewContents: '[pack-contents]',
  previewContentsHeader: '[pack-contents-header]',
  previewContentsItems: '[pack-contents-items]',
  previewItem: '[preview-pack-item]',
  previewItemImage: '[preview-pack-item-img]',
  previewItemTitle: '[preview-pack-item-title]',
  packContainerId: '[pack-container-id]'
};

var getPackContainerId = function getPackContainerId() {
  packContainerId = parseInt($(dom.packContainerId).attr('pack-container-id'));
};

var getMaxItemCount = function getMaxItemCount() {
  maxItems = parseInt($(dom.addPackToCart).attr('data-item-count'));
};

var updateATC = function updateATC(ids) {
  $(dom.addPackToCart).attr('data-variant-ids', ids.join(',')).attr('active-options', currentPackItems.length);
  if (ids.length == maxItems) {
    $(dom.addPackToCart).removeAttr('disabled');
    $(dom.itemQtyUpdate).filter('[update-pack-qty="1"]').attr('disabled', 'disabled');
    $(dom.addToPackBtn).attr('disabled', 'disabled');
  }
};

var updatePreviewItem = function updatePreviewItem(index, item) {
  var $previewItem = $(dom.previewItem).filter('[preview-pack-item="' + index + '"]');
  if (item) {
    $previewItem.find(dom.previewItemImage).attr('src', item.image).attr('alt', item.alt);
    $previewItem.find(dom.previewItemTitle).text(item.title);
    $previewItem.addClass('is-selected');
  } else {
    $previewItem.find(dom.previewItemImage).attr('src', '').attr('alt', 'Product image placeholder');
    $previewItem.find(dom.previewItemTitle).text('Scent ' + (index + 1));
    $previewItem.removeClass('is-selected');
  }
};

var updatePackItem = function updatePackItem(item) {
  if (item) {
    var $packItem = $(dom.packItem).filter('[data-variant-id="' + item.id + '"]');
    var $qtyInput = $packItem.find(dom.itemQtyInput);
    var qty = parseInt($qtyInput.val()) + 1;
    $qtyInput.val(qty);
    $packItem.addClass('is-active');
  }
};

var resetUI = function resetUI() {
  $(dom.addPackToCart).removeAttr('data-skus');
  $(dom.packItem).removeClass('is-active');
  $(dom.itemQtyInput).val(0);
  $(dom.addPackToCart).attr('disabled', 'disabled');
  $(dom.itemQtyUpdate).removeAttr('disabled');
  $(dom.addToPackBtn).removeAttr('disabled');
};

var updateUI = function updateUI() {
  resetUI();
  var ids = [packContainerId];
  for (var i = 0; i < maxItems; i++) {
    var item = currentPackItems[i] || false;
    if (item) {
      ids.push(item.id);
    }
    updatePreviewItem(i, item);
    updatePackItem(item);
  }
  updateATC(ids);
};

var getItemData = function getItemData(id) {
  var variantIds = void 0;
  var idIndex = void 0;
  var packProductId = Object.keys(_Product.productData).find(function (productId) {
    variantIds = _Product.productData[productId].variants.map(function (variant) {
      return variant.id;
    });
    idIndex = variantIds.indexOf(id);
    if (idIndex !== -1) {
      return true;
    }
  });
  var packProduct = _Product.productData[packProductId];
  var itemData = {
    id: variantIds[idIndex],
    title: packProduct.title,
    image: packProduct.image.src,
    alt: packProduct.image.alt
  };
  return itemData;
};

var addPackItemById = function addPackItemById(id) {
  if (currentPackItems.length < maxItems) {
    var item = getItemData(id);
    currentPackItems.push(item);
    updateUI();
  } else {
    alert('Error, too many items.');
  }
};

var removePackItemById = function removePackItemById(id) {
  var skipCount = 0;
  currentPackItems = currentPackItems.filter(function (item) {
    if (item.id !== id || skipCount > 0) {
      return true;
    } else {
      skipCount++;
      return false;
    }
  });
  updateUI();
};

var enableMobileStickyElements = function enableMobileStickyElements(headerHeight, previewItemsHeight) {
  $(dom.previewContents).addClass('is-sticky');
  $(dom.previewContents).css('marginBottom', previewItemsHeight);
  $(dom.previewContentsItems).css('top', headerHeight);
};

var disableMobileStickyElements = function disableMobileStickyElements() {
  if ($(dom.previewContents).hasClass('is-sticky')) {
    $(dom.previewContents).removeClass('is-sticky');
    $(dom.previewContents).removeAttr('style');
    $(dom.previewContentsItems).removeAttr('style');
  }
};

var unlockDesktopStickyElements = function unlockDesktopStickyElements() {
  return $(dom.packContents).removeClass('is-locked');
};

var lockDesktopStickyElements = function lockDesktopStickyElements() {
  return $(dom.packContents).addClass('is-locked');
};

var toggleScrollActions = function toggleScrollActions() {
  if (window.innerWidth < 992) {
    unlockDesktopStickyElements();

    var headerHeight = $(dom.header).outerHeight();
    var previewItemsHeight = $(dom.previewContentsItems).outerHeight();
    var previewHeaderBottom = $(dom.previewContentsHeader).offset().top + $(dom.previewContentsHeader).outerHeight() - headerHeight;
    if (window.scrollY > previewHeaderBottom) {
      enableMobileStickyElements(headerHeight, previewItemsHeight);
    } else {
      disableMobileStickyElements();
    }
  } else {
    disableMobileStickyElements();

    var packMainBottom = $(dom.packMain).offset().top + $(dom.packMain).outerHeight();
    var packContentsStickyHeight = $(dom.packSticky).outerHeight(true);
    var packContentsStickyTop = $('body').hasClass('countdown-active') ? 160 : 120;
    var scrollOffset = packMainBottom - packContentsStickyHeight - packContentsStickyTop;
    if (window.scrollY >= scrollOffset) {
      lockDesktopStickyElements();
    } else {
      unlockDesktopStickyElements();
    }
  }
};

var addToPack = function addToPack(event) {
  if (currentPackItems.length < maxItems - 1) {
    var $this = $(event.currentTarget);
    var $packItem = $(dom.packItem).has($this);
    var id = parseInt($packItem.attr('data-variant-id'));
    addPackItemById(id);
  } else {
    alert('Error, too many items.');
  }
};

var removePackItemByIndex = function removePackItemByIndex() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (isNaN(index)) return console.error('[BVA] Missing item index to remove from pack.');
  var _currentPackItems$ind = currentPackItems[index].id,
      id = _currentPackItems$ind === undefined ? false : _currentPackItems$ind;

  if (!id) return console.error('[BVA] Could not find matching pack item to remove.');
  removePackItemById(id);
};

var removeFromPack = function removeFromPack(event) {
  var $this = $(event.currentTarget);
  var index = parseInt($this.attr('remove-from-pack'));
  console.log('index', index);
  removePackItemByIndex(index);
};

var updatePackItemQty = function updatePackItemQty(event) {
  var $this = $(event.currentTarget);
  var updateBy = parseInt($this.attr('update-pack-qty'));
  var $packItem = $(dom.packItem).has($this);
  var id = parseInt($packItem.attr('data-variant-id'));
  var isRemove = updateBy < 0 ? true : false;
  if (isRemove) {
    removePackItemById(id);
  } else {
    addPackItemById(id);
  }
};

var bindUIActions = function bindUIActions() {
  $(dom.addToPackBtn).on('click', addToPack);

  $(dom.removeFromPackBtn).on('click', removeFromPack);

  $(dom.itemQtyUpdate).on('click', updatePackItemQty);

  $(window).on('scroll touchstart touchend touchmove', toggleScrollActions);
};

var init = exports.init = function init() {
  getPackContainerId();
  getMaxItemCount();
  bindUIActions();
  toggleScrollActions();
  console.log('[BVA] Module Loaded: Product Pack');
};